import { inject, injectable } from 'inversify';
import AddressesRepository from '../../data/AddressesRepository';
import { GetAddressByLocationUseCaseParams } from './types';

@injectable()
class GetAddressByLocationUseCase {
  @inject(AddressesRepository)
  private addressesRepository!: AddressesRepository;

  async execute(params: GetAddressByLocationUseCaseParams) {
    return this.addressesRepository.getAddressByLocation(params);
  }
}

export default GetAddressByLocationUseCase;
